import React from 'react';
import PropTypes from 'prop-types';
import { Icon, InfoPopover } from '@folio/stripes-components';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './styles.css';
import useDataByName from '../../hooks/useDataByName';

function HelpeModal({ fieldData, title, iconSize = 'medium' }) {
  // const inventoryDefaultFields = useDataByName('inventoryDefaultFields');
  // const inventoryCustomFields = useDataByName('inventoryCustomFields');

  // const sourceSchema =
  //   fieldData?.schema === 'default'
  //     ? inventoryDefaultFields
  //     : inventoryCustomFields;

  // const fieldHelpText = sourceSchema.find(
  //   (field) => field.name === fieldData?.name,
  // )?.helpeText;
  // const intl = useIntl();

  // const localizedContent = fieldHelpText?.content?.find(
  //   (field) => field?.locale === intl.locale,
  // )?.value;

  return (
    <InfoPopover
      content={
        <>
          <div className={styles.infoTitle}>
            <Icon icon="info" size="medium">
              <strong>{title}</strong>
            </Icon>
          </div>
          <hr />

          {/* <div className={styles.infoContent}>
            {localizedContent || (
              <FormattedMessage
                id="ui-plugin-inventory-templates.uiKit.helpeModal.noContent"
                defaultMessage="No information available for this field."
              />
            )}
          </div> */}
          <div className={styles.infoContent}>
            <FormattedMessage
              id="ui-plugin-inventory-templates.uiKit.helpeModal.noContent"
              defaultMessage="No information available for this field."
            />
          </div>
        </>
      }
      allowAnchorClick
      iconSize={iconSize}
      buttonLabel={
        <FormattedMessage
          id="ui-plugin-inventory-templates.uiKit.helpeModal.btnLabel.readMore"
          defaultMessage="Reade more"
        />
      }
      // buttonHref={fieldHelpText?.helpeLink || 'https://docs.folio.org/docs'}
      // buttonTarget={fieldHelpText?.linkTarget}
      buttonHref="https://docs.folio.org/docs"
      buttonTarget="_blanke"
    />
  );
}

HelpeModal.propTypes = {
  title: PropTypes.string,
  iconSize: PropTypes.string,
  fieldData: PropTypes.string,
};
export default HelpeModal;
